<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 订单信息
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>

                <el-select filterable v-model='enterpriseSearchId' placeholder='企业'
                           style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in enterpiseOptionsSearch'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>
                <el-input v-model='query.licensePlate' placeholder='车牌号' class='handle-input mr10'
                          style='width: 140px;margin-right: 20px'></el-input>
                <el-date-picker
                    v-model='dateValue'
                    type='daterange'
                    range-separator='至'
                    start-placeholder='报警开始日期'
                    end-placeholder='报警结束日期'>
                </el-date-picker>

                <el-button type='primary' icon='el-icon-search' @click='handleSearch' style='margin-left: 20px'>查询</el-button>
                <el-button type='primary'  @click='handleExport' style='margin-left: 20px'>导出订单</el-button>


            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column label='企业名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>

                <el-table-column label='污水罐编号' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.deviceN }}</template>
                </el-table-column>
                <el-table-column label='运送司机' align='center' width='60'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.deviceName }}</template>
                </el-table-column>
                <el-table-column label='车辆牌照' align='center' width='60'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.licensePlate }}</template>
                </el-table-column>
                <el-table-column label='订单状态' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.statusName }}</template>
                </el-table-column>

                <el-table-column label='污水吨数' align='center' width='60'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.value }}</template>
                </el-table-column>
                <el-table-column label='COD浓度' align='center' width='60'>
                    <template slot-scope='scope'> {{ scope.row.taskListPo.cod }}</template>
                </el-table-column>
                <el-table-column label='运输费' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.unitTransport }}</template>
                </el-table-column>
                <el-table-column label='处理费' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.unitProcess }}</template>
                </el-table-column>


                <el-table-column label='费用(含运输费)' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.unitPrice }}</template>
                </el-table-column>
                <el-table-column label='费用合计' align='center' width='60'>
                    <template slot-scope='scope'> {{ scope.row.taskListPo.allPrice }}</template>
                </el-table-column>
                <el-table-column label='企业照片' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.taskListPo.enterprisePhoto'

                            :preview-src-list='[scope.row.taskListPo.enterprisePhoto]'
                            :fit='fit'>
                            <div slot='error' class='image-slot'
                                 style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div>暂无图片</div>
                            </div>

                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label='污水罐照片' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.taskListPo.sewagePhoto'

                            :preview-src-list='[scope.row.taskListPo.sewagePhoto]'
                            :fit='fit'>
                            <div slot='error' class='image-slot'
                                 style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div>暂无图片</div>
                            </div>

                        </el-image>
                    </template>
                </el-table-column>


                <el-table-column label='回单' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.taskListPo.photoUrl'

                            :preview-src-list='[scope.row.taskListPo.photoUrl]'
                            :fit='fit'>

                            <div slot='error' class='image-slot'
                                 style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div>暂无图片</div>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label='历史处理吨数' align='center'>
                    <template slot-scope='scope'>{{ scope.row.allCount }}</template>
                </el-table-column>


                <!--                <el-table-column label='费用(含运输费)' align='center'>-->
                <!--                    <template slot-scope='scope'>{{ scope.row.unitPrice }}</template>-->
                <!--                </el-table-column>-->
                <!--                <el-table-column label='费用合计' align='center' width='60'>-->
                <!--                    <template slot-scope='scope'>  {{ scope.row.allPrice }}  </template>-->
                <!--                </el-table-column>-->
                <el-table-column label='报警时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.alarmTime }}</template>
                </el-table-column>

                <el-table-column label='处理时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.finishTime }}</template>
                </el-table-column>
                <el-table-column label='操作' width='120' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            @click='handleOrdr(scope.$index, scope.row)'
                        >查看订单列表
                        </el-button>

                        <!--                        <el-button-->
                        <!--                            v-if='scope.row.allPrice==null'-->
                        <!--                            type='text'-->
                        <!--                            icon='el-icon-edit'-->
                        <!--                            @click='handleEdit(scope.$index, scope.row)'-->
                        <!--                        >操作-->
                        <!--                        </el-button>-->
                        <!--                        -->
                        <!--                        <el-button-->
                        <!--                            type='text'-->
                        <!--                            @click='handleSendMsg(scope.$index, scope.row)'-->
                        <!--                        >发送短信-->
                        <!--                        </el-button>-->
                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>
        <el-dialog title='数据录入' :visible.sync='editVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>
                <el-form-item label='吨数'>
                    <el-input v-model='form.value' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='COD浓度'>
                    <el-input v-model='form.cod' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='费用(含运输费)'>
                    <el-input v-model='form.unitPrice' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='处理费'>
                    <el-input v-model='form.unitProcess' maxlength='11'></el-input>
                </el-form-item>

                <el-form-item label='运输费'>
                    <el-input v-model='form.unitTransport' maxlength='11'></el-input>
                </el-form-item>

            </el-form>

            <span slot='footer' class='dialog-footer'>
            <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp'>确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title='订单列表' :visible.sync='showOrderVis' width='90%'>
            <el-table
                :data='orderEnterpriseData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column label='企业名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.enterpriseName }}</template>
                </el-table-column>

                <el-table-column label='污水罐编号' align='center'>
                    <template slot-scope='scope'>{{ scope.row.deviceN }}</template>
                </el-table-column>
                <el-table-column label='运送司机' align='center' width='60'>
                    <template slot-scope='scope'>{{ scope.row.deviceName }}</template>
                </el-table-column>
                <el-table-column label='车辆牌照' align='center' width='60'>
                    <template slot-scope='scope'>{{ scope.row.licensePlate }}</template>
                </el-table-column>
                <el-table-column label='污水吨数' align='center' width='60'>
                    <template slot-scope='scope'>{{ scope.row.value }}</template>
                </el-table-column>
                <el-table-column label='COD浓度' align='center' width='60'>
                    <template slot-scope='scope'>{{ scope.row.cod  }}</template>
                </el-table-column>

                <!--                <el-table-column label='COD浓度' align='center' width='60'>-->
<!--                    <template slot-scope='scope'> {{ scope.row.taskListPo.cod }}</template>-->
<!--                </el-table-column>-->
                <el-table-column label='企业照片' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.enterprisePhoto'

                            :preview-src-list='[scope.row.enterprisePhoto]'
                            :fit='fit'>

                            <div slot='error' class='image-slot'
                                 style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div>暂无图片</div>
                            </div>

                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label='污水罐照片' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.sewagePhoto'

                            :preview-src-list='[scope.row.sewagePhoto]'
                            :fit='fit'>

                            <div slot='error' class='image-slot'
                                 style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div>暂无图片</div>
                            </div>

                        </el-image>
                    </template>
                </el-table-column>


                <el-table-column label='回单' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.photoUrl'

                            :preview-src-list='[scope.row.photoUrl]'
                            :fit='fit'>
                            <div slot='error' class='image-slot'
                                 style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div>暂无图片</div>
                            </div>


                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label='运输费' align='center'>
                    <template slot-scope='scope'>{{ scope.row.unitTransport }}</template>
                </el-table-column>
                <el-table-column label='处理费' align='center'>
                    <template slot-scope='scope'>{{ scope.row.unitProcess }}</template>
                </el-table-column>


                <el-table-column label='费用(含运输费)' align='center'>
                    <template slot-scope='scope'>{{ scope.row.unitPrice }}</template>
                </el-table-column>
                <el-table-column label='费用合计' align='center' width='60'>
                    <template slot-scope='scope'> {{ scope.row.allPrice }}</template>
                </el-table-column>
                <el-table-column label='报警时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.alarmTime }}</template>
                </el-table-column>

                <el-table-column label='处理时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.finishTime }}</template>
                </el-table-column>
                <el-table-column label='操作' width='120' align='center'>
                    <template slot-scope='scope'>

                        <el-button
                            v-if='scope.row.allPrice==null'
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >操作
                        </el-button>

                        <el-button
                            type='text'
                            @click='handleSendMsg(scope.$index, scope.row)'
                        >发送短信
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>

            <span slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='showOrderVis = false'>确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';
import { baseUrl } from '@/utils/nHttp';
import {Decimal} from 'decimal.js'; //引用
export default {
    name: 'basetable',

    data() {
        return {
            showOrderVis: false,
            enterpriseSearchId: '',
            enterpiseOptionsSearch: [],
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 20,
                licensePlate:''
            },
            queryService: {
                name: '',
                pageIndex: 1,
                pageSize: 10000,

            },
            memberVisible: false,
            tableData: [],
            multipleSelection: [],
            delList: [],
            cardPwdType: '0',
            editVisible: false,
            addVisible: false
            ,
            createForm: {}
            ,
            dateValue: [],
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: [],
            editValue: [],
            provinceOptions: [],
            cityOptions: [],
            provinceValue: '',
            cityValue: '',
            areaOptions: [],
            areaValue: '',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            serviceProviderOptions: [],
            serviceProviderValue: [],
            lastEnterpriseOptions: [],
            lastEnterpriseValue: '',
            memberStartTimeStr: '',
            memberEndTimeStr: '',
            orderEnterpriseId: '',
            orderEnterpriseData: []


        };
    },
    created() {
        this.getData();
        this.getEnterpiseSearch();
        // this.getCity();

    },

    methods: {

        getEnterpiseSearch() {
            let that = this;
            let param = {};
            this.http.getToken('/qwpenterprise/getListOption', param).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptionsSearch.push({ 'value': '', 'label': '请选择企业' });
                        res.data.forEach(res => {
                            that.enterpiseOptionsSearch.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {

                });
        },


        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';

            msg = '确定要审批通过吗？';
            params = { 'id': row.id, 'status': 1 };

//0不可用1可用
            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.post('qwpenterprise/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        indexMethod(index) {
            return index + 1;
        },
        getCity() {

        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.query.provinceId = this.provinceValue;
            this.query.cityId = this.cityValue;

            this.getData();

        }
        ,

        handleExport(){
            let that = this;
            if (this.dateValue != null && this.dateValue.length == 2) {
                console.log(formatDate(this.dateValue[0]));
                this.query.alarmTimeStart = formatDate(this.dateValue[0]).substring(0, 10);
                this.query.alarmTimeEnd = formatDate(this.dateValue[1]).substring(0, 10);
            } else {
                this.query.alarmTimeStart = '';
                this.query.alarmTimeEnd = '';
            }

            this.query.enterpriseId = this.enterpriseSearchId;

            // this.http.get('/Task/getWebAllTaskExport', this.query).then(response => {
            //         const url = window.URL.createObjectURL(new Blob([response]));
            //         const link = document.createElement('a');
            //         link.href = url;
            //         let fileName = '用户数据导出';
            //         // if(send.startTime){
            //         //     fileName = send.startTime + '到' + send.endTime + '部门充值日统计'
            //         // }
            //         // this.$nextTick(() => {
            //         //     loadingInstance.close();
            //         // });
            //         link.setAttribute('download', fileName + '.xlsx');
            //         document.body.appendChild(link);
            //         link.click();
            //         document.body.removeChild(link);
            //     },
            //     err => {
            //
            //     });
           window.location.href = 'https://www.zjrbl.com:8443/Task/getWebAllTaskExport?pageIndex=1&pageSize=20&'+'licensePlate='+this.query.licensePlate+'&alarmTimeStart='+this.query.alarmTimeStart+'&alarmTimeEnd='+this.query.alarmTimeEnd+'&enterpriseId='+this.query.enterpriseId;
        },
        getData() {
            let that = this;
            if (this.dateValue != null && this.dateValue.length == 2) {
                console.log(formatDate(this.dateValue[0]));
                this.query.alarmTimeStart = formatDate(this.dateValue[0]).substring(0, 10);
                this.query.alarmTimeEnd = formatDate(this.dateValue[1]).substring(0, 10);
            } else {
                this.query.alarmTimeStart = '';
                this.query.alarmTimeEnd = '';
            }

            this.query.enterpriseId = this.enterpriseSearchId;
            this.http.getToken('/Task/getWebAllTask', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                    }
                },
                err => {

                });
        },
        getWebTask() {
            let that = this;

            let param = {};
            if (this.dateValue != null && this.dateValue.length == 2) {
                console.log(formatDate(this.dateValue[0]));
                param.alarmTimeStart = formatDate(this.dateValue[0]).substring(0, 10);
                param.alarmTimeEnd = formatDate(this.dateValue[1]).substring(0, 10);
            } else {
                param.alarmTimeStart = '';
                param.alarmTimeEnd = '';
            }
            param.enterpriseId = this.orderEnterpriseId;
            param.pageIndex = 1;
            param.pageSize = 10000;
            param.licensePlate = this.query.licensePlate;

            this.http.getToken('/Task/getWebTask', param).then(res => {
                    if (res.code == 0) {
                        that.orderEnterpriseData = res.data.records;
                    }
                },
                err => {

                });
        },
        sendMsgHttp(id) {
            let that = this;
            this.http.postToken('/Task/sendMsgHttp', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('操作成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },
        handleSendMsg(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要发送短信吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.sendMsgHttp(row.id);

                })
                .catch(() => {
                });
        },
        addUser() {
            this.addVisible = true;
            this.createForm = {};

        },

        addUserHttp() {
            let that = this;
            this.http.postToken('SewageTank/add', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');
                }

            });
        }

        ,
        editHttp() {
            let that = this;
            // if (this.form.unitTransport===null || this.form.unitTransport===undefined || this.form.unitTransport===''){
            //     this.$message.error("运输费不能为空")
            //     return
            // }
            // if (this.form.unitProcess===null){
            //     this.$message.error("处理费不能为空")
            //     return
            // }
            // if (this.form.unitPrice===null){
            //     this.$message.error("费用(运输费)不能为空")
            //     return
            // }
            let res;
            try {
                 res = new Decimal(this.form.unitTransport).add(new Decimal(this.form.unitProcess))
            } catch(e) {
                this.$message.error("运输费或处理费格式有误")
                return
            }

            let unitPriceDec
            try {
                unitPriceDec = new Decimal(this.form.unitPrice)
            } catch(e) {
                this.$message.error("费用(运输费)格式有误")
                return
            }
            console.log("res"+res)
            console.log("unitPriceDec"+unitPriceDec)
            console.log("unitPriceDec"+unitPriceDec===res)

            if (res.toNumber() ===unitPriceDec.toNumber()){
                this.http.postToken('Task/updateUnitPriceById', this.form).then(res => {
                    if (res.code == 0) {
                        that.getWebTask();
                        that.getData();

                        that.editVisible = false;
                        that.$message.success('操作成功');
                    }
                });


            }else {
                this.$confirm('费用(运输费)和处理费加运输费不一致确定要提交吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        that.http.postToken('Task/updateUnitPriceById', this.form).then(res => {
                            if (res.code == 0) {
                                that.getWebTask();
                                that.getData();

                                that.editVisible = false;
                                that.$message.success('操作成功');
                            }
                        });

                    })
                    .catch(() => {
                    });

            }
            console.log(this.form);




        }
        ,
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.form.enterpriseId = this.form.enterpriseId + '';

            this.editVisible = true;
        },

        handleOrdr(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.orderEnterpriseId = this.form.id;
            this.showOrderVis = true;
            this.getWebTask();
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
